import { render } from "./Dashbard.vue?vue&type=template&id=0f33917c"
const script = {}

import exportComponent from "/Users/hank/winho/gx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__